export const nomeIndicadores = {
  indicadores_painel_geral: 'Indicadores do Painel Geral',
  acidente_vascular_cerebral: 'Acidente Vascular Cerebral - AVC',
  artropatia_de_quadril: 'Artropatia de Quadril',
  cancer_de_mama: 'Câncer de Mama',
  cancer_de_prostata: 'Câncer de Próstata',
  sepse_e_choque_septico: 'Sepse e Choque Séptico',
  sindrome_coronariana_aguda: 'Síndrome Coronariana Aguda - SCA',
};
